import { Snackbar } from '@material-ui/core';
import styled from 'styled-components';

export const StyledSnackbar = styled(Snackbar)`
  .MuiPaper-root {
    /* Margin from left of screen */
    margin-left: 86px;
  }
`;
